// import React, { useState, useEffect } from 'react';

// interface TimerProps {
//   drawTime: string | Date |undefined;
// }

// const Timer: React.FC<TimerProps> = ({ drawTime }) => {
//   const [remainingTime, setRemainingTime] = useState<number>(0);
//   const [isExpired, setIsExpired] = useState<boolean>(false);

//   useEffect(() => {
//     const targetTime =drawTime && new Date(drawTime).getTime();

//     const updateTimer = () => {
//       const currentTime = new Date().getTime();
//       const timeLeft = targetTime &&Math.max((targetTime - currentTime) / 1000, 0);
//       if(timeLeft){
//         setRemainingTime(timeLeft);
//         setIsExpired(timeLeft <= 0);
//       }

//     };

//     updateTimer();

//     const intervalId = setInterval(updateTimer, 1000);

//     return () => clearInterval(intervalId);
//   }, [drawTime]);

//   const formatTime = (timeInSeconds: number): string => {
//     const hours = Math.floor(timeInSeconds / 3600);
//     const minutes = Math.floor((timeInSeconds % 3600) / 60);
//     const seconds = Math.floor(timeInSeconds % 60);

//     const pad = (num: number): string => num < 10 ? `0${num}` : `${num}`;

//     if (hours > 0) {
//       return `${hours}:${pad(minutes)}:${pad(seconds)}`;
//     }
//     return `${pad(minutes)}:${pad(seconds)}`;
//   };

//   return (
//     <div className="relative flex flex-col items-center">
//       <img
//         src="/assets/clock.png"
//         alt="Clock"
//         width={300}
//         height={180}
//         className="object-contain"
//       />
//       <span
//         className={`absolute mt-8 inset-0 flex items-center justify-center text-2xl font-bold ${
//           isExpired ? 'text-red-500' : 'text-white'
//         }`}
//       >
//         {isExpired ? '00:00' : formatTime(remainingTime)}
//       </span>
//       <p className="text-white text-md font-bold underline mt-2">FOR BINGO</p>
//     </div>
//   );
// };
// export default Timer

import React, { useState, useEffect } from "react";
import useWindowSize from "./utils/useWindowSize";

interface TimerProps {
  drawTime: string | Date | undefined;
  isPurchase?: boolean | undefined;
}

const Timer: React.FC<TimerProps> = ({ drawTime, isPurchase }) => {
  const [remainingTime, setRemainingTime] = useState<string | null>(null);
  const [isExpired, setIsExpired] = useState<boolean>(false);
  const { width } = useWindowSize();
  useEffect(() => {
    const updateTimer = () => {
      const { timer, isExpired } = RemainingTimer(drawTime);
      setRemainingTime(timer);
      setIsExpired(isExpired);
    };

    updateTimer();

    const intervalId = setInterval(updateTimer, 1000);

    return () => clearInterval(intervalId);
  }, [drawTime]); // Re-run the effect whenever drawTime changes

  return (
    <div>
      <div className="relative flex flex-col items-center">
        <div className="relative flex items-end justify-center w-[110px] md:w-[200px] xl:w-[300px]">
          <img
            src="/assets/clock.png"
            alt="Clock"
            className={`object-contain   `}
          />
          <span
            className={`absolute  xl:text-2xl md:text-xl text-sm bottom-[12%] md:bottom-[14%] xl:bottom-[18%] flex items-center justify-center   font-bold text-white `}
          >
            {remainingTime}
          </span>
        </div>
        <p
          className={`text-white  font-bold underline mt-1 md:text-base xl:text-xl text-[14px]  `}
        >
          {isPurchase ? 'TICKET DEADLINE' : 'BINGO START'} {" "}
        </p>
      </div>
    </div>
  );
};

export default Timer;

export const RemainingTimer = (
  drawTime: string | Date | undefined
): { timer: string | null; isExpired: boolean; beforeTime: boolean } => {
  if (!drawTime) {
    return { timer: null, isExpired: true, beforeTime: true };
  }

  const targetTime = new Date(drawTime).getTime();
  const currentTime = new Date().getTime();
  const timeLeft = Math.max((targetTime - currentTime) / 1000, 0);

  const isExpired = timeLeft <= 0;
  const beforeTime = timeLeft <= 5;
  const formatTime = (timeInSeconds: number): string => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = Math.floor(timeInSeconds % 60);

    const pad = (num: number): string => (num < 10 ? `0${num}` : `${num}`);

    if (hours > 0) {
      return `${hours}:${pad(minutes)}:${pad(seconds)}`;
    }
    return `${pad(minutes)}:${pad(seconds)}`;
  };

  return {
    timer: isExpired ? "00:00" : formatTime(timeLeft),
    isExpired: isExpired,
    beforeTime: beforeTime,
  };
};
